import { BOOKING_STATUS, BOOKING_STATUS_CONFIG } from "@shared/enum/booking-status.enum";
import moment from "moment";

export const createSlug = (text: string) => {
  const diacriticsMap: { [key: string]: string } = {
    à: 'a',
    á: 'a',
    ả: 'a',
    ã: 'a',
    ạ: 'a',
    ă: 'a',
    ắ: 'a',
    ằ: 'a',
    ẳ: 'a',
    ẵ: 'a',
    ặ: 'a',
    â: 'a',
    ấ: 'a',
    ầ: 'a',
    ẩ: 'a',
    ẫ: 'a',
    ậ: 'a',
    đ: 'd',
    è: 'e',
    é: 'e',
    ẻ: 'e',
    ẽ: 'e',
    ẹ: 'e',
    ê: 'e',
    ế: 'e',
    ề: 'e',
    ể: 'e',
    ễ: 'e',
    ệ: 'e',
    ì: 'i',
    í: 'i',
    ỉ: 'i',
    ĩ: 'i',
    ị: 'i',
    ò: 'o',
    ó: 'o',
    ỏ: 'o',
    õ: 'o',
    ọ: 'o',
    ô: 'o',
    ố: 'o',
    ồ: 'o',
    ổ: 'o',
    ỗ: 'o',
    ộ: 'o',
    ơ: 'o',
    ớ: 'o',
    ờ: 'o',
    ở: 'o',
    ỡ: 'o',
    ợ: 'o',
    ù: 'u',
    ú: 'u',
    ủ: 'u',
    ũ: 'u',
    ụ: 'u',
    ư: 'u',
    ứ: 'u',
    ừ: 'u',
    ử: 'u',
    ữ: 'u',
    ự: 'u',
    ỳ: 'y',
    ý: 'y',
    ỷ: 'y',
    ỹ: 'y',
    ỵ: 'y',
  };
  const noDiacritics = text
    .toLowerCase()
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[^\u0000-\u007E]/g, (char) => diacriticsMap[char] || char);
  return noDiacritics.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
};
export const formatCurrency = (price: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};
export const renderStar = (number: number): any => {
  return [...Array(number)];
};

export const scrollToTop = (behavior?: ScrollBehavior) => {
  window.scrollTo({ top: 0, left: 0, behavior: behavior });
}

export const convertToUserTimeZone = (utcTime: string): any => {
  return moment.utc(utcTime).toDate();
}

export const getUTCOffset = (): string => {
  const timezoneOffsetInMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(timezoneOffsetInMinutes / 60);
  const offsetSign = timezoneOffsetInMinutes > 0 ? '-' : '+';
  return `(UTC${offsetSign}${offsetHours})`;
}

export const addZoneToDateTime = (dateTime: string): string => {
  if (!dateTime.endsWith('Z')) {
    return dateTime + 'Z';
  }
  return dateTime;
}

export const getCurrencySymbol = (currencyCode: string, locale: string = 'en-US'): string => {
  const formatted = (0).toLocaleString(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return formatted.replace(/[\d\s.,]/g, '').trim();
}

export function getBookingStatusKey(status: string): keyof typeof BOOKING_STATUS | '' {
  const matched = Object.entries(BOOKING_STATUS).find(([, value]) => value === status);
  return matched ? matched[0] as keyof typeof BOOKING_STATUS : '';
}

export function getBookingStatusStyle(status: string): string {
  const key = getBookingStatusKey(status);
  return key ? BOOKING_STATUS_CONFIG[key]?.style : '';
}

export function formatToUTCDateTime(dateStr: string): string {
  if (!dateStr) return '';

  const cleanedStr = dateStr.split('.')[0] + 'Z';
  const date = new Date(cleanedStr);

  const timezoneOffsetInMinutes = date.getTimezoneOffset();
  const offsetHours = Math.floor(timezoneOffsetInMinutes / 60);
  const offsetSign = offsetHours < 0 ? '+' : '-';
  const paddedOffset = `${offsetSign}${Math.abs(offsetHours)}`;
  const pad = (n: number) => n.toString().padStart(2, '0');

  const formatted = `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())} (UTC${paddedOffset})`;
  return formatted;
}

export function formatToUtcZ(input: string): string {
  return input.split('.')[0].replace(/Z?$/, 'Z');
}
